import useAuth from "../../../commons/hooks/use-auth";
import { Redirect } from "react-router-dom";
import { RouteType } from "./CreateRoutes";

type CheckValidationRouteType = {
  children: any;
  route: RouteType;
  inAuthenticatedRoute?: string;
  inAuthorizedRoute?: string;
};

const CheckValidationRoute = ({
  children,
  route,
  inAuthenticatedRoute,
  inAuthorizedRoute,
}: CheckValidationRouteType) => {
  const { isAuthenticated, isAuthorized } = useAuth({ routePermissions: route.permissions });

  if (route.inSecure) return children;

  if (!isAuthenticated) return <Redirect to={inAuthenticatedRoute} />;

  if (!isAuthorized) return <Redirect to={inAuthorizedRoute} />;

  return children;
};

export default CheckValidationRoute;
